<template>
    <div class="motion">
        <div class="motion-search">
            <search-box :list="searchText" :form="form">
                <template slot="search-box-btn">
                    <div class="btn">
                        <el-button type="primary" icon="el-icon-search"> 搜索</el-button>
                        <el-button type="primary" @click="handleAdd"><i class="el-icon-plus"></i> 新增动作</el-button>
                    </div>
                </template>
            </search-box>
        </div>
        <div class="motion-category">
            <el-button type="info"><i class="el-icon-document-copy"></i> 类目配置</el-button>
        </div>
        <div class="motion-table">
            <el-table :data="tableData" style="width: 100%;" height="54vh">
                <el-table-column type="index" label="编号" width="60">
                </el-table-column>
                <el-table-column prop="itemName" label="动作名称" width="180">
                </el-table-column>
                <el-table-column prop="showVideoName" label="动作视频" width="200">
                </el-table-column>
                <el-table-column prop="catalogFirst" label="一级类目" width="180">
                    <template slot-scope="scope">
                        <span>{{ onText(scope.row.catalogFirst) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="catalogSecondSubject" label="二级主题类目" width="180">
                    <template slot-scope="scope">
                        <span>{{ onText(scope.row.catalogSecondSubject) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="catalogSecondBody" label="二级部位类目" width="180">
                    <template slot-scope="scope">
                        <span>{{ onText(scope.row.catalogSecondBody) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="difficulty" label="难度等级" width="80">
                </el-table-column>
                <el-table-column prop="purposeDesc" label="训练目的" width="180">
                </el-table-column>
                <el-table-column prop="trainPlan" label="训练频次" width="180">
                </el-table-column>
                <el-table-column prop="sportDevice" label="设备" width="100">
                </el-table-column>
                <el-table-column prop="standardDesc" label="要点" width="180">
                    <template slot-scope="scope">
                        <div class="spaces">{{ scope.row.standardDesc }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="attentionDesc" label="注意事项" width="180">
                    <template slot-scope="scope">
                        <div class="spaces">{{ scope.row.attentionDesc }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="onVedio" label="上传视频" width="80">
                </el-table-column>
                <el-table-column prop="labelImage" label="入口缩略图" width="120">
                    <template slot-scope="scope">
                        <img class="label-image" :src="scope.row.labelImage" alt="">
                    </template>
                </el-table-column>
                <el-table-column prop="showVideo" label="GIF图" width="120">
                    <template slot-scope="scope">
                        <img class="label-image" :src="scope.row.showVideo" alt="">
                    </template>
                </el-table-column>
                <el-table-column prop="showVideoMedia" label="媒资ID" width="80">
                </el-table-column>
                <el-table-column prop="classetailStatus" label="状态" width="80">
                </el-table-column>
                <el-table-column prop="updateTime" label="添加时间" width="180">
                </el-table-column>
                <el-table-column label="设置" class="setting" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="danger" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="pagination" :page-sizes="[10, 20, 30, 50, 100]" :current-page="pagination.page"
                :page-size="pagination.pageSize" :total="pagination.total" layout="total, prev, pager, next"
                @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
    </div>
</template>

<script>
import SearchBox from '../components/searchBox.vue';
export default {
    data () {
        return {
            searchText: [
                {
                    label: '动作库',
                    type: 'motionName',
                    placeholder: '请输入动作库名称',
                },
                {
                    label: '一级类目',
                    type: 'yiji',
                    placeholder: '请输入一级类目',
                },
                {
                    label: '二级主题类目',
                    type: 'erjizhuti',
                    placeholder: '请输入二级主题类目',
                },
                {
                    label: '二级部位类目',
                    type: 'erjibuwei',
                    placeholder: '请输入二级部位类目',
                },
                {
                    label: '难度等级',
                    type: 'nandu',
                    placeholder: '请输入难度等级',
                },
            ],
            form: {
                motionName: '',
                yiji: '',
                erjizhuti: '',
                erjibuwei: '',
                nandu: ''
            },
            tableData: [{
                sportDetailId: 1, // 动作id
                sportDomainId: 1, // 动作domianId
                itemName: '展臂深呼吸',// 动作名称
                showVideoName: 'HP-3-展臂深呼吸-SNOW.mp4', //视频名称
                purposeDesc: '全身协调XXXX', // 训练目的
                trainPlan: '30秒/组*30组', //训练频次
                catalogFirst: [
                    {
                        classDetailId: 11,
                        id: 0,
                        isDisplay: true,
                        isDisplayCode: "2GA",
                        propertyDetailDesc: "燃脂",
                        propertyDetailId: 81,
                        propertyId: 5
                    }
                ], //  一级类目
                catalogSecondSubject: [
                    {
                        classDetailId: 11,
                        id: 0,
                        isDisplay: true,
                        isDisplayCode: "2GA",
                        propertyDetailDesc: "减脂减重",
                        propertyDetailId: 21,
                        propertyId: 6
                    },
                ], // 二级主题类目
                catalogSecondBody: [
                    {
                        classDetailId: 11,
                        id: 0,
                        isDisplay: false,
                        isDisplayCode: "2GB",
                        propertyDetailDesc: "背部",
                        propertyDetailId: 21,
                        propertyId: 6
                    },
                    {
                        classDetailId: 11,
                        id: 0,
                        isDisplay: true,
                        isDisplayCode: "2GA",
                        propertyDetailDesc: "燃脂减重",
                        propertyDetailId: 63,
                        propertyId: 6
                    },
                    {
                        classDetailId: 11,
                        id: 0,
                        isDisplay: false,
                        isDisplayCode: "2GB",
                        propertyDetailDesc: "腰部",
                        propertyDetailId: 83,
                        propertyId: 6
                    },
                    {
                        classDetailId: 11,
                        id: 0,
                        isDisplay: false,
                        isDisplayCode: "2GB",
                        propertyDetailDesc: "臀部",
                        propertyDetailId: 84,
                        propertyId: 6
                    },
                    {
                        classDetailId: 11,
                        id: 0,
                        isDisplay: true,
                        isDisplayCode: "2GA",
                        propertyDetailDesc: "全身",
                        propertyDetailId: 86,
                        propertyId: 6
                    }], // 二级部位类目
                difficulty: '困难', // 难度等级
                sportDevice: '瑜伽垫', //训练设备
                standardDesc: '· 俯身屈肘支撑于地面，身体呈一条直线\r\n· 耳朵远离肩膀，保持背部平整\r\n· 双手与肩同宽，肩膀在手肘正上方', // 训练要点
                attentionDesc: '・人体对准人体识别框\r\n・穿着较贴身得衣物\r\n・不要让他人进入画面\r\n・不要逆光拍摄\r\n・调大设备声音\r\n・中途离开识别不到人体超过一段时间会自动退出', // 注意事项
                onVedio: '', // 上传视频
                labelImage: 'https://oss-mrjz.sensetime.com/dev/pushup-image/sportlib/label/plank_support.png', //入口缩略图
                showVideo: 'https://oss-mrjz.sensetime.com/dev/pushup-image/sportlib/clipped/plank_support.gif', // 动作视频GIF图
                showVideoMedia: '1', //媒资ID
                classetailStatus: '2JC', //动作上线状态
                updateTime: '2023-03-27 14:03:25', // 添加的时间

            },
            {
                sportDetailId: 1, // 动作id
                sportDomainId: 1, // 动作domianId
                itemName: '展臂深呼吸',// 动作名称
                showVideoName: 'HP-3-展臂深呼吸-SNOW.mp4', //视频名称
                purposeDesc: '全身协调XXXX', // 训练目的
                trainPlan: '30秒/组*30组', //训练频次
                catalogFirst: [
                    {
                        classDetailId: 11,
                        id: 0,
                        isDisplay: true,
                        isDisplayCode: "2GA",
                        propertyDetailDesc: "燃脂",
                        propertyDetailId: 81,
                        propertyId: 5
                    },
                    {
                        classDetailId: 11,
                        id: 0,
                        isDisplay: true,
                        isDisplayCode: "2GA",
                        propertyDetailDesc: "减重",
                        propertyDetailId: 81,
                        propertyId: 5
                    }
                ], //  一级类目
                catalogSecondSubject: [
                    {
                        classDetailId: 11,
                        id: 0,
                        isDisplay: true,
                        isDisplayCode: "2GA",
                        propertyDetailDesc: "减脂减重",
                        propertyDetailId: 21,
                        propertyId: 6
                    },
                ], // 二级主题类目
                catalogSecondBody: [
                    {
                        classDetailId: 11,
                        id: 0,
                        isDisplay: false,
                        isDisplayCode: "2GB",
                        propertyDetailDesc: "背部",
                        propertyDetailId: 21,
                        propertyId: 6
                    },
                    {
                        classDetailId: 11,
                        id: 0,
                        isDisplay: true,
                        isDisplayCode: "2GA",
                        propertyDetailDesc: "燃脂减重",
                        propertyDetailId: 63,
                        propertyId: 6
                    },
                    {
                        classDetailId: 11,
                        id: 0,
                        isDisplay: false,
                        isDisplayCode: "2GB",
                        propertyDetailDesc: "腰部",
                        propertyDetailId: 83,
                        propertyId: 6
                    },
                    {
                        classDetailId: 11,
                        id: 0,
                        isDisplay: false,
                        isDisplayCode: "2GB",
                        propertyDetailDesc: "臀部",
                        propertyDetailId: 84,
                        propertyId: 6
                    },
                    {
                        classDetailId: 11,
                        id: 0,
                        isDisplay: true,
                        isDisplayCode: "2GA",
                        propertyDetailDesc: "全身",
                        propertyDetailId: 86,
                        propertyId: 6
                    }], // 二级部位类目
                difficulty: '困难', // 难度等级
                sportDevice: '瑜伽垫', //训练设备
                standardDesc: '· 俯身屈肘支撑于地面，身体呈一条直线\r\n· 耳朵远离肩膀，保持背部平整\r\n· 双手与肩同宽，肩膀在手肘正上方', // 训练要点
                attentionDesc: '・人体对准人体识别框\r\n・穿着较贴身得衣物\r\n・不要让他人进入画面\r\n・不要逆光拍摄\r\n・调大设备声音\r\n・中途离开识别不到人体超过一段时间会自动退出', // 注意事项
                onVedio: '', // 上传视频
                labelImage: 'https://oss-mrjz.sensetime.com/dev/pushup-image/sportlib/label/plank_support.png', //入口缩略图
                showVideo: 'https://oss-mrjz.sensetime.com/dev/pushup-image/sportlib/clipped/plank_support.gif', // 动作视频GIF图
                showVideoMedia: '1', //媒资ID
                classetailStatus: '2JC', //动作上线状态
                updateTime: '2023-03-27 14:03:25', // 添加的时间

            },
            {
                sportDetailId: 1, // 动作id
                sportDomainId: 1, // 动作domianId
                itemName: '展臂深呼吸',// 动作名称
                showVideoName: 'HP-3-展臂深呼吸-SNOW.mp4', //视频名称
                purposeDesc: '全身协调XXXX', // 训练目的
                trainPlan: '30秒/组*30组', //训练频次
                catalogFirst: [
                    {
                        classDetailId: 11,
                        id: 0,
                        isDisplay: true,
                        isDisplayCode: "2GA",
                        propertyDetailDesc: "燃脂",
                        propertyDetailId: 81,
                        propertyId: 5
                    },
                    {
                        classDetailId: 11,
                        id: 0,
                        isDisplay: true,
                        isDisplayCode: "2GA",
                        propertyDetailDesc: "减重",
                        propertyDetailId: 81,
                        propertyId: 5
                    }
                ], //  一级类目
                catalogSecondSubject: [
                    {
                        classDetailId: 11,
                        id: 0,
                        isDisplay: true,
                        isDisplayCode: "2GA",
                        propertyDetailDesc: "减脂减重",
                        propertyDetailId: 21,
                        propertyId: 6
                    },
                ], // 二级主题类目
                catalogSecondBody: [
                    {
                        classDetailId: 11,
                        id: 0,
                        isDisplay: false,
                        isDisplayCode: "2GB",
                        propertyDetailDesc: "背部",
                        propertyDetailId: 21,
                        propertyId: 6
                    },
                    {
                        classDetailId: 11,
                        id: 0,
                        isDisplay: true,
                        isDisplayCode: "2GA",
                        propertyDetailDesc: "燃脂减重",
                        propertyDetailId: 63,
                        propertyId: 6
                    },
                    {
                        classDetailId: 11,
                        id: 0,
                        isDisplay: false,
                        isDisplayCode: "2GB",
                        propertyDetailDesc: "腰部",
                        propertyDetailId: 83,
                        propertyId: 6
                    },
                    {
                        classDetailId: 11,
                        id: 0,
                        isDisplay: false,
                        isDisplayCode: "2GB",
                        propertyDetailDesc: "臀部",
                        propertyDetailId: 84,
                        propertyId: 6
                    },
                    {
                        classDetailId: 11,
                        id: 0,
                        isDisplay: true,
                        isDisplayCode: "2GA",
                        propertyDetailDesc: "全身",
                        propertyDetailId: 86,
                        propertyId: 6
                    }], // 二级部位类目
                difficulty: '困难', // 难度等级
                sportDevice: '瑜伽垫', //训练设备
                standardDesc: '· 俯身屈肘支撑于地面，身体呈一条直线\r\n· 耳朵远离肩膀，保持背部平整\r\n· 双手与肩同宽，肩膀在手肘正上方', // 训练要点
                attentionDesc: '・人体对准人体识别框\r\n・穿着较贴身得衣物\r\n・不要让他人进入画面\r\n・不要逆光拍摄\r\n・调大设备声音\r\n・中途离开识别不到人体超过一段时间会自动退出', // 注意事项
                onVedio: '', // 上传视频
                labelImage: 'https://oss-mrjz.sensetime.com/dev/pushup-image/sportlib/label/plank_support.png', //入口缩略图
                showVideo: 'https://oss-mrjz.sensetime.com/dev/pushup-image/sportlib/clipped/plank_support.gif', // 动作视频GIF图
                showVideoMedia: '1', //媒资ID
                classetailStatus: '2JC', //动作上线状态
                updateTime: '2023-03-27 14:03:25', // 添加的时间

            }
            ],
            pagination: {
                page: 1,
                pageSize: 10,
                total: 10,
            },
        }
    },
    components: {
        SearchBox
    },
    methods: {
        aaa (item) {
            console.log(item, "0000000000")
        },
        handleAdd () {
            console.log(this.form, "lllllll")
        },
        // 编辑
        hndleEdit () { },
        // 分页
        handleSizeChange (val) {
            console.log(val)
        },
        handleCurrentChange (val) {
            console.log(val)
        },
        onText (oldArr) {
            let arr = oldArr.map(item => {
                return item.isDisplay && item.propertyDetailDesc
            }).filter(Boolean)
            console.log(arr, "0AAAAAAAAAAAAAAAAAAAAAAAAA")
            let str = arr.toString()
            return str
        }
    },

}
</script>
<style lang="scss" scoped>
.motion {

    &-search {
        border-bottom: 1px solid #f0f0f0;

        .btn {
            float: right;
        }
    }

    &-category {
        width: 100%;
        margin-top: 16px;
    }

    &-table {
        max-height: 59%;
        overflow: hidden;

        /deep/ .label-image {
            width: 100px;
        }

        /deep/ .spaces {
            white-space: break-spaces;
        }

        /deep/ .el-table__header {
            thead>tr {
                & :last-child {
                    background: #f2f3f5;
                    color: #1d2129;
                }
            }
        }

        /deep/ .el-table__body-wrapper {
            overflow-x: scroll;

            &::-webkit-scrollbar {
                height: 17px;
            }

            &::-webkit-scrollbar-thumb {
                background: #ccc;
                border-radius: 17px;
            }

            &::-webkit-scrollbar-corner {
                height: 10px;
            }

        }

        /deep/ .el-table>.el-table__fixed-right {
            right: 0 !important;
        }

        /deep/ .el-table__body {
            min-height: 47vh;
            max-height: 47vh;


        }
    }
}
</style>